import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  page: 1,
  itemsPerPage: 10,
};

const overweightSlice = createSlice({
  name: 'overweightUI',
  initialState,
  reducers: {
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setItemsPerPage: (state, action) => {
      state.itemsPerPage = action.payload;
    },
    resetFilters: () => initialState,
  },
});

export const { setPage, setItemsPerPage, resetFilters } = overweightSlice.actions;
const allOverweightReducer = overweightSlice.reducer;
export default allOverweightReducer;
